import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-flexbox-grid';
import { FormattedHTMLMessage } from 'react-intl';
import { map } from 'ramda';

import ActionButton from 'components/ActionButton';
import DocumentHeaderRow from '../DocumentHeaderRow';
import DocumentTitle from '../DocumentTitle';

const EditStartButton = ({ mode, name, onStartEdit, addNewText }) => (
  <Row key={name} center="xs" end="sm">
    <Col xs={12} style={{ marginBottom: '1rem', marginTop: '1rem' }}>
      <ActionButton
        localeId={
          addNewText ? addNewText : (mode === 'edit' && 'dictionary.edit') || (mode === 'create' && name + '.addNew')
        }
        border
        long
        secondary
        onClick={() => {
          onStartEdit(name);
        }}
      />
    </Col>
  </Row>
);

EditStartButton.propTypes = {
  mode: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onStartEdit: PropTypes.func.isRequired,
  addNewText: PropTypes.string,
};

const CommonHeader = ({
  names,
  localeId,
  editing,
  startEdit,
  infoElement,
  allowHCPUse,
  infoText = '',
  addNewText = '',
  descElement,
  mode = 'edit',
  widerInfoTextArea = false,
  disableEditStartButton = false,
}) => (
  <DocumentHeaderRow>
    <Col xs={12} sm={7} md={widerInfoTextArea ? 8 : true} lg={widerInfoTextArea ? 9 : true}>
      <DocumentTitle localeId={localeId} infoElement={infoElement} />
      {infoText && (
        <Row style={{ marginTop: '0.5em' }}>
          <Col xs sm={widerInfoTextArea ? 11 : 9}>
            <p className="bold">
              <FormattedHTMLMessage id={infoText} />
            </p>
          </Col>
        </Row>
      )}
      {!editing && descElement && descElement}
    </Col>
    {!editing && (
      <Col
        xs={12}
        sm={5}
        md={widerInfoTextArea ? 4 : true}
        lg={widerInfoTextArea ? 3 : true}
        style={{ marginTop: '1rem' }}
      >
        {!disableEditStartButton &&
          map(
            n =>
              (window.__ROLE__ !== 'DOCTOR' || (allowHCPUse && allowHCPUse.indexOf(n) > -1)) && (
                <EditStartButton key={n} name={n} mode={mode} onStartEdit={startEdit} addNewText={addNewText} />
              ),
          )(names)}
      </Col>
    )}
  </DocumentHeaderRow>
);

CommonHeader.propTypes = {
  names: PropTypes.array.isRequired,
  localeId: PropTypes.string.isRequired,
  infoText: PropTypes.string,
  addNewText: PropTypes.string,
  descElement: PropTypes.node,
  allowHCPUse: PropTypes.array,
  infoElement: PropTypes.node,
  startEdit: PropTypes.func.isRequired,
  mode: PropTypes.string,
  editing: PropTypes.object,
  widerInfoTextArea: PropTypes.bool,
  disableEditStartButton: PropTypes.bool,
};

export default CommonHeader;
